<div class="p-6 bg-white border border-gray-200 rounded-lg shadow sm:p-6 md:p-6 min-w-[310px] lg:min-w-[450px]">
    <form class="form-container space-y-5"
          [formGroup]="authForm"
          action="#">
        <h5 class="element elm1 text-xl font-medium text-gray-900 dark:text-white">Inicia sesión</h5>

        <div class="element elm2">
            <div>
                <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email</label>
                <input formControlName="email" type="email" name="email" id="email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" placeholder="name@email.com" required />
            </div>
            @for( validation of validationMessages.email!;track $index){
                @if(getValidationPersonalFromControl(validation, 'email')){
                    <div>
                        <span  class="mt-2 text-sm text-red-600 dark:text-red-500" style="color:red;"> {{ validation.message }} </span>
                    </div>
                }
            }
            <div>
                <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contraseña</label>
                <input formControlName="password" type="password" name="password" id="password" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" required />
            </div>
            @for( validation of validationMessages.password!;track $index){
                @if(getValidationPersonalFromControl(validation, 'password')){
                    <div>
                        <span  class="mt-2 text-sm text-red-600 dark:text-red-500" style="color:red;"> {{ validation.message }} </span>
                    </div>
                }
            }
        </div>
        <div class="element elm3 grid grid-cols-12 space-y-2 mx-auto lg:mx-0">
            <div class="col-span-12 lg:col-span-6">
                @if (!isLoading) {
                <button class="button-primary" (click)="emitForm()">
                    Iniciar sesión
                </button>
                }@else {
                <button disabled type="button" class="button-primary">
                    <svg aria-hidden="true" role="status" class="inline w-4 h-4 me-3 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2"/>
                    </svg>
                    Cargando...
                </button>
                }
            </div>
            <a routerLink="/forgot-password" class="col-span-12 lg:col-span-6 text-sm text-black mx-auto lg:mx-0 underline dark:text-blue-500">Olvidé mi contraseña</a>
        </div>

        <div class="element elm4 border-t border-gray-300"></div>

        <div class="element elm5 space-y-2 flex flex-col justify-start lg:justify-start">
            <div class="text-sm font-medium text-gray-500 dark:text-gray-300 mx-auto lg:mx-0">
                ¿No tenés una cuenta?
            </div>
            <div class="col-span-7 mx-auto lg:mx-0">
                <button class="button-primary px-4" [routerLink]="'/create-account'">
                    Crear una cuenta
                </button>
            </div>
        </div>

    </form>
</div>
